<section class="auth-page">
  <div class="auth-page__container">
    @switch (state()) {
      @case ('verifying') {
        <div class="auth-page__status">
          <span class="auth-page__status-icon auth-page__status-icon--spin" aria-hidden="true">
            <app-icon [icon]="spinnerIcon" [size]="48" color="currentColor" />
          </span>
          <h1 class="auth-page__title">Verificando tu cuenta…</h1>
          <p class="auth-page__text">Un momento, estamos validando tu enlace.</p>
        </div>
      }

      @case ('verified') {
        <div class="auth-page__status">
          <span class="auth-page__status-icon auth-page__status-icon--success" aria-hidden="true">
            <app-icon [icon]="successIcon" [size]="48" color="currentColor" />
          </span>
          <h1 class="auth-page__title">Cuenta verificada</h1>
          <p class="auth-page__text">Ya puedes iniciar sesión.</p>
          <app-button variant="primary" size="md" (click)="openLoginModal()">
            Iniciar sesión
          </app-button>
        </div>
      }

      @case ('already-verified') {
        <div class="auth-page__status">
          <span class="auth-page__status-icon auth-page__status-icon--success" aria-hidden="true">
            <app-icon [icon]="successIcon" [size]="48" color="currentColor" />
          </span>
          <h1 class="auth-page__title">Tu cuenta ya estaba verificada</h1>
          <p class="auth-page__text">
            No tienes que volver a verificarla. Inicia sesión y a jugar.
          </p>
          <app-button variant="primary" size="md" (click)="openLoginModal()">
            Iniciar sesión
          </app-button>
        </div>
      }

      @case ('error') {
        <div class="auth-page__status">
          <span class="auth-page__status-icon auth-page__status-icon--warning" aria-hidden="true">
            <app-icon [icon]="errorIcon" [size]="48" color="currentColor" />
          </span>
          <h1 class="auth-page__title">No pudimos verificar tu cuenta</h1>
          <p class="auth-page__text">
            El enlace puede haber caducado o ya fue utilizado. Puedes pedir que
            te lo reenviemos.
          </p>
          <app-button
            variant="primary"
            size="md"
            [loading]="resending()"
            [disabled]="resending()"
            (click)="onResend()"
          >
            Reenviar correo de verificación
          </app-button>
        </div>
      }
    }
  </div>
</section>
